import { Type } from '@angular/core';
import { Question } from './Question';

export class QuestionComponent {
    constructor(public component: Type<any>, public question: Question) {}
}
